import { fetchData, apiURL } from './api_helper';

const createClass = classOptions => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes`;
  fetchData(endpointURL, 'POST', classOptions).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const checkEmailAvailability = (classId, email) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/emailAvailibilityChecker`;
  fetchData(endpointURL, 'POST', { email }).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const inviteStudents = (classId, invitations) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/invite`;
  fetchData(endpointURL, 'POST', invitations).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getClasses = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getAggregatedSkillStat = classId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/skillStats`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getStudentsFromClass = classId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/students`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const moveStudent = (classId, rosterId, newClassId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/moveStudent`;
  fetchData(endpointURL, 'POST', { classId, rosterId, newClassId }).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error.response);
  });
}));

const removeStudent = (classId, rosterId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/students/${rosterId}`;
  fetchData(endpointURL, 'DELETE').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getClassById = classId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getLatestAssignments = (classId, counter) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/assignments/latest/${counter}`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getNextUpTasks = (classId, counter) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/lessons/nextUp/${counter}`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getSuggestedTasks = (classId, counter) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/lessons/suggestedByInterests/${counter}`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getPracticeTasks = classId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/lessons/practiceWeaknesses`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const updateClass = (classId, settings) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}`;
  fetchData(endpointURL, 'PUT', settings).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const deleteClass = classId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}`;
  fetchData(endpointURL, 'DELETE').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getUpcomingLessons = classId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/lessons/upcomingLessons`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const mergeClasses = data => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/merge`;
  fetchData(endpointURL, 'POST', data).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error.response);
  });
}));

const getOpenAssignments = (classId, page, limit, order, direction) => new Promise((resolve, reject) => {
  // eslint-disable-next-line
  const endpointURL = `${apiURL}/api/v2/classes/${classId}/assignments/open/${page}?limit=${limit}&order=${order}&direction=${direction}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const getClosedAssignments = (classId, page, limit, order, direction) => new Promise((resolve, reject) => {
  // eslint-disable-next-line
  const endpointURL = `${apiURL}/api/classes/${classId}/assignments/closed/${page}?limit=${limit}&order=${order}&direction=${direction}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const getClassLeaderboard = (classId, limit) => new Promise((resolve, reject) => {
  let endpointURL = `${apiURL}/api/classes/${classId}/leaderboard`;
  if (limit) {
    endpointURL += `?limit=${limit}`;
  }
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    }).catch((error) => {
      reject(error);
    });
});

const getClassReport = (classId, interval) => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/reports/${interval}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    }).catch((error) => {
      reject(error);
    });
});

const getClassReportOverview = classId => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/reportOverview`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    }).catch((error) => {
      reject(error);
    });
});

const downloadClassRerportPdf = (classId, interval) => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${classId}/reports/${interval}/pdf`;
  fetchData(endpointURL, 'GET', { generatePdf: true })
    .then((result) => {
      resolve(result.data);
    }).catch((error) => {
      reject(error);
    });
});

const getDataStore = accessKey => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/dataStore/${accessKey}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    }).catch((error) => {
      reject(error);
    });
});

const getPreviousChamps = data => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/${data.classId}/leaderboardHistory/${data.page}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    }).catch((error) => {
      reject(error);
    });
});

const getAllStudent = data => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/allStudent/list`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    }).catch((error) => {
      reject(error);
    });
});

const getClassesDktUser = scope => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/classes/dkt?scope=${scope}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    }).catch((error) => {
      reject(error);
    });
});


export default {
  createClass,
  checkEmailAvailability,
  inviteStudents,
  getClasses,
  getAggregatedSkillStat,
  getStudentsFromClass,
  moveStudent,
  removeStudent,
  getClassById,
  getLatestAssignments,
  getNextUpTasks,
  getSuggestedTasks,
  getPracticeTasks,
  updateClass,
  deleteClass,
  getUpcomingLessons,
  mergeClasses,
  getOpenAssignments,
  getClosedAssignments,
  getClassLeaderboard,
  getClassReport,
  getClassReportOverview,
  downloadClassRerportPdf,
  getDataStore,
  getPreviousChamps,
  getAllStudent,
  getClassesDktUser
};



// WEBPACK FOOTER //
// ./src/api/classes.js